/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";

const Form = ({ children, ...props }) => (
    <form
        {...props}
        css={css`
            width: 100%;
            display: flex;
            flex: 1;
            flex-direction: column;
            & > * {
                margin: 10px 0;
            }
        `}
    >
        {children}
    </form>
);

export default Form;
